export default "indexedDB" in window && "databases" in window.indexedDB;
